import { styled } from "theme/default/styled";

import { setColor_2b3e50 } from "../../../../theme/setter/setColorsValues/setColor_2b3e50";
import { setFontSize_14px } from "../../../../theme/setter/setFontSizeValues/setFontSize_14px";
import { setFontWeight500 } from "../../../../theme/setter/setFontWeightValues/setFontWeight500";

export const SDataKey = styled.span`
  ${setFontSize_14px};
  ${setFontWeight500};
  ${setColor_2b3e50};
  width: 400px;
`;
